import React from "react";
import { EmptyComponent } from "../common/EmptyComponent";
import Loadable from "react-loadable";
import { useSelector } from "react-redux";
import { UISelectors } from "../../redux/selectors";

const BubbleWrapperLoader = Loadable({
  loader: () => import(/* webpackChunkName: "container/bubble" */ "./Bubble"),
  loading: EmptyComponent
});

const BubbleWrapper = () => {
  const bubble = useSelector(UISelectors.bubble);
  if (bubble?.containerID) {
    return <BubbleWrapperLoader />;
  } else {
    return null;
  }
};

export default BubbleWrapper;
